import { SHOPIFY_ATTRIBUTES } from '~/lib/constants'
import linkResolver from '~/lib/link-resolver'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import { AddressCardProps } from '~/components/Account/Logged/AddressBook/AdressItem'

import { attributesAsObject } from '~/utils/attributes'
import { getIntlLocale } from '~/utils/locales'

import serializePrice from '~/data/serialize-price'

export type OrderProduct = {
  id: string
  sku?: string
  name?: string
  href?: string
  size?: string
  image?: string
  label?: string
  price?: string
  isUniqueSize?: boolean
  quantity?: number
  total?: string
}

export type OrderProps = {
  id?: string
  reference?: string
  shippingAddress?: AddressCardProps
  date?: string
  status?: string
  total?: string
  shippingPrice?: string
  products: OrderProduct[]
}

export default function serializeOrder({
  order,
  locale,
}: {
  order: any
  locale: string
}): OrderProps {
  const intl = getIntlLocale(locale)
  const products = order?.lineItems?.map((product) => ({
    ...product,
    customAttributes: attributesAsObject(product?.customAttributes ?? []),
  }))

  return {
    id: order?.id,
    reference: order?.name?.replace(/#/g, ''),
    date: order?.processedAt
      ? new Intl.DateTimeFormat(intl)
          .format(new Date(order?.processedAt))
          ?.replace(/\//g, '.')
      : null,
    total:
      serializePrice(
        locale,
        order?.totalPrice?.currencyCode,
        order?.totalPrice?.amount,
      ) ?? null,
    status: order?.fulfillmentStatus,
    shippingPrice:
      serializePrice(
        locale,
        order?.totalShippingPrice?.currencyCode,
        order?.totalShippingPrice?.amount,
      ) ?? null,
    shippingAddress: order?.shippingAddress ?? null,
    products: products?.map((product) => {
      return {
        id: product?.variant?.id,
        sku: product?.variant?.sku,
        isUniqueSize:
          Boolean(product?.customAttributes?._isUniqueSize) ?? false,
        name: product?.customAttributes?.[SHOPIFY_ATTRIBUTES.name] ?? null,
        href: linkResolver({
          content: { component: STORYBLOK_TYPES.PRODUCT },
          slug: product?.customAttributes?.[SHOPIFY_ATTRIBUTES.slug],
        }),
        size: product?.variant?.title,
        image: product?.customAttributes?.[SHOPIFY_ATTRIBUTES.image] ?? null,
        label: product?.customAttributes?.[SHOPIFY_ATTRIBUTES.designer] ?? null,
        price: serializePrice(
          locale,
          product?.originalTotalPrice?.currencyCode,
          product?.originalTotalPrice?.amount,
        ),
        quantity: product?.quantity,
        total: serializePrice(
          locale,
          product?.originalTotalPrice?.currencyCode,
          product?.originalTotalPrice?.amount * product?.quantity,
        ),
      }
    }),
  }
}
